import { FunctionComponent } from 'react';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { ISecondaryButtonProps } from './SecondaryButton.interface';

export const SecondaryButton: FunctionComponent<ISecondaryButtonProps> = (props) => {
  const {
    label,
    disabled,
    startIcon,
    flexShrink = 0,
    onClick,
    disabledTooltip,
    sx,
  } = props;

  if (disabledTooltip && disabled) {
    return (
      <Tooltip title={disabledTooltip}>
        <span>
          <Button
            color={'secondary'}
            startIcon={startIcon}
            disabled={disabled}
            onClick={onClick}
            sx={{ flexShrink, ...sx }}
          >
            {label}
          </Button>
        </span>
      </Tooltip>
    );
  }

  return (
    <Button
      color={'secondary'}
      startIcon={startIcon}
      disabled={disabled}
      onClick={onClick}
      sx={{ flexShrink, ...sx }}
    >
      {label}
    </Button>
  );
};
